var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-map',{ref:"mapRef",style:({ height: _vm.height, width: '100%' }),attrs:{"center":_vm.center,"zoom":14,"map-type-id":"roadmap","options":{
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    gestureHandling: 'greedy',
  }}},_vm._l((_vm.polygons),function(p){return _c('gmap-polygon',{key:p.pk,attrs:{"paths":p.paths,"options":_vm.polygonOptions(p)},on:{"click":function($event){return _vm.$emit('field-click', p.pk)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }